import { render, staticRenderFns } from "./ListDissSovet.vue?vue&type=template&id=46bb0ed3&scoped=true"
import script from "./ListDissSovet.vue?vue&type=script&lang=js"
export * from "./ListDissSovet.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "46bb0ed3",
  null
  
)

export default component.exports